// @ts-ignore
import Axios, { AxiosError, AxiosResponse } from 'axios';
import Collection from '@/stores/abstract/Collection';
import Model from '@/stores/abstract/Model';
import axiosInstance from '@/helpers/axios';
import {generateLog} from '@/helpers/functions';

const CancelToken: any = Axios.CancelToken;
const URL: string = '/pms-interface';
const ICON: string = '/icons';
let cancel: any;

// @ts-ignore
export class PMSInterface extends Model<IPMSInterface> implements IPMSInterface {
  id!: number;
  OID!: number;
  type!: 0;
  title!: string;
  backend_ip!: string;
  backend_port!: number;
  backend_password!: string;
  pms_ip!: string;
  pms_port!: number;
  pms_port_encrypt!: boolean;
  period_database_resync!: number;
  period_disconnected_email!: number;
  period_keep_alive!: number;
  text_encoding!: string;
  guest_adult_age!: number;
  language_OID_default!: number;
  language_selection!: PMSInterface_languageSelection_type;
  timezone!: string;
  specific!: null | IPMSInterface_Specific_FIAS;

  constructor(attributes: any = {}, parentCollection?: any) {
    super(
      {...{
          id: -1,
          OID: -1,
          type: 0,
          title: '',
          backend_ip: '',
          backend_port: 2000,
          backend_password: '',
          pms_ip: '',
          pms_port: 0,
          pms_port_encrypt: false,
          period_database_resync: 0,
          period_disconnected_email: 0,
          period_keep_alive: 0,
          text_encoding: '',
          guest_adult_age: 0,
          language_OID_default: 0,
          language_selection: 0,
          timezone: '',
          specific: null		//Dependent on the type selection.
        }, ...attributes}, // Default values
      parentCollection,
    );
  }

  urlRoot(): string {
    return URL;
  }

  url(): string {
    return `${this.urlRoot()}`;
  }
}

export default class PMSInterfaceCollection extends Collection<PMSInterface>
{
  routeName = 'pms-interface';
  model(): Constructor<PMSInterface>
  {
    return PMSInterface;
  }
  url(): string
  {
    return URL;
  }
  icons(): string
  {
    return ICON;
  }

  /*
   * Patch
   */
  public item_load(): Promise<iResponse<IPMSInterface|null>>
  {
  //Get interface from database.
    return axiosInstance.get( `${this.url()}`, { headers: { 'X-NoCamelCase': 'true' } } )
      .then(
          ( response: AxiosResponse<iReturnStatus_noCamel> ) =>
          {
          //Was all ok?
            const   data = response.data;

            if ( data.response_code !== 200 )
            {
            //Request failed.
              return { error: data.error?.message || "Unknown error" };
            }

          //Return data.
          //
          //Notice:
          //In case there is no interface defined, returned data will be null.
            return { data: data.data };
          }
      ).catch(
        ( e: AxiosError | Error ) =>
        {
          generateLog( { route: this.routeName, message: e } );

          return { error: e.message };
        }
      );
  }
  public item_update( id: string | number, interface_data: IPMSInterface ): Promise<iResponse<IPMSInterface>>
  {
  //Insert or update item (in database and NHI).
  //
  //Notice:
  //Can take longer time as NHI has to destroy and recreate interface to PMS.
    return axiosInstance.put( `${this.url()}/update/${id}`, interface_data, { headers: { 'X-NoCamelCase': 'true' } } )
      .then(
        ( response: AxiosResponse<iReturnStatus_noCamel> ) =>
        {
        //Was all ok?
          const   data = response.data;

          if ( data.response_code !== 200 )
          {
          //Request failed.
            return { error: data.error?.message || "Unknown error" };
          }

        //Return data.
          return { data: data.data };
        }
      ).catch(
        ( e: AxiosError | Error ) =>
        {
          generateLog( { route: this.routeName, message: e } );

          return { error: e.message };
        }
      );
  }
  public item_remove(id: string | number, interface_data: IPMSInterface): Promise<iResponse<IPMSInterface>>
  {
  //Remove interface (from database and NHI).
    return axiosInstance.put( `${this.url()}/remove/${id}`, interface_data, { headers: { 'X-NoCamelCase': 'true' } } )
      .then( 
        ( response: AxiosResponse<iReturnStatus_noCamel> ) =>
        {
        //Was all ok?
          const   data = response.data;

          if ( data.response_code !== 200 )
          {
          //Request failed.
            return { error: data.error?.message || "Unknown error" };
          }

        //Return data.
          return { data: data.data };
        }
      ).catch(
        ( e: AxiosError | Error ) =>
        {
          generateLog( { route: this.routeName, message: e } );

          return { error: e.message };
        }
      );
  }
}
